export enum DialogResultStatus {
  Cancel = 0,
  Ok = 1,
}
